import React, { useEffect, useState } from 'react'
import "./disputedetail.scss"
import { useLocation, useNavigate } from 'react-router-dom';
import { tokenImages } from '../../constants/tokenImages';
import Environment from '../../utils/Environment';
import { API_URL } from '../../utils/ApiUrl';
import axios from 'axios';
import { toast } from 'react-toastify';
import Loader from '../../hooks/loader';
import { use } from 'react';
import { useSocket } from '../../contexts/SocketContext';
import { uploadProofOnIPFS } from '../../hooks/IPFS/UploadProofOnIPFS';
import SubmitProofAgain from '../../hooks/write/submitProofAgain';
import { useWeb3React } from '@web3-react/core';
import TaskDisputedDetails from '../../hooks/similarTaskDetail/taskDisputedDetails';
import FetchDisputeTimer from '../../hooks/similarTaskDetail/fetchDisputeTimer';
import CustomToast from '../../components/CustomToast';
import getDollarValueOfToken from '../../services/tokenPrice_usd';
import { intitial_production_eth_id } from '../../constants/id';
const DisputeDetail = () => {

    const location = useLocation();
    const navigate = useNavigate();
    const { taskData, status } = location.state;
    const [message, setMessage] = useState('')
    const [messages, setMessages] = useState([]);
    const [disputeChats, setDisputeChats] = useState();
    const [selectedItem, setSelectedItem] = useState();
    const [loading, setLoader] = useState(false);
    const [error, setError] = useState(null);
    const [chatEnabled, setChatEnabled] = useState(true)
    const [file, setFile] = useState(null);
    const socket = useSocket();
    console.log(file, "filefilefilefilefilefilefilefilefilefilefile");
    console.log(message, "messagemessagemessagemessagemessagemessage");
    console.log(taskData?.hasCreatorSubmit2ndProof, "hasCreatorSubmit2ndProof", taskData, "taskDatataskDatataskDatataskDatataskDatataskData");


    console.log(chatEnabled, "chatEnabledchatEnabledchatEnabled");

    const [screenWidth, setScreenWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => setScreenWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);

        return () => window.removeEventListener("resize", handleResize);
    }, []);

   

    const handleFileUpload = (event) => {
        const uploadedFile = event.target.files[0];
        const maxFileSize = 10 * 1024 * 1024; // 10 MB

        if (uploadedFile) {
            if (uploadedFile.size > maxFileSize) {
                toast.error("File size should not exceed 10 MB");
                return; // don't set anything
            }
            setFile(uploadedFile);
        }
    };


    const handleRemoveFile = () => {
        setFile(null);
    };

    const imgeUrl = async (e) => {
        let accessToken = localStorage.getItem("accessToken");

        // Create a FormData object to send the image
        let formData = new FormData();
        formData.append("image", e); // Assuming 'e' is the image file

        const config = {
            method: "post",
            url: `${API_URL}metadata/upload-image`,
            headers: {
                "Content-Type": "multipart/form-data", // Correct content type for file uploads
                Authorization: `Bearer ${accessToken}`,
            },
            data: formData, // Send formData with the image file
        };

        try {
            let response = await axios(config);
            if (response) {
                return response.data.url; // Return the URL for further processing
            }
        } catch (error) {
            // Extract the error message from the API response and return it
            if (error.response) {
                const apiErrorMessage =
                    error.response.data.message || error.response.data;
                console.error("API Error:", apiErrorMessage);
                return { error: apiErrorMessage }; // Return an object containing the error message
            } else {
                console.error("Error occurred while uploading image:", error);
                return {
                    error: "An unknown error occurred while uploading the image.",
                }; // Return a default error message
            }
        }
    };

    const handleSubmit = async (cRes, mergedProofArrayHash) => {
        if (!file || !message) {
            // toast.warn("Please fill in the message and select a file.");
            CustomToast.show('warning', 'Warning!', 'Please fill in the message and select a file.')
            return;
        }
        let accessToken = localStorage.getItem("accessToken");
        setLoader(true);
        // Step 1: Upload the file to get the URL or an error
        let uploadedImageResponse = await imgeUrl(file); // Call the function to upload the image and get the URL or error

        // Step 2: Check if the response contains an error
        if (uploadedImageResponse && uploadedImageResponse.error) {
            // toast.error(`Failed to upload the file: ${uploadedImageResponse.error}`);
            CustomToast.show('error', 'Error!', `Failed to upload the file: ${uploadedImageResponse.error}`)

            setLoader(false);
            return;
        }

        // If no error, get the uploaded image URL
        let uploadedImageUrl = uploadedImageResponse;

        // Step 3: Prepare data for the PATCH request
        const dataToSubmit = {
            message: message, // Replace with the actual unique code if it's dynamic
            proofIpfsHash: `ipfs://${mergedProofArrayHash[0]}/`,
            transactionHash: cRes?.transactionHash,
            proofOfWork: [uploadedImageUrl], // Add the uploaded image URL to this array
            ...(!taskData?.hasCreator && { disputeId: disputeChats?.id }),
            contractTaskId: taskData?.contractTaskId,
            taskId: id,
        };

        try {
            // Replace 'your-api-endpoint' with the actual endpoint
            await axios.post(`${API_URL}disputes-chat`, dataToSubmit, {
                headers: {
                    "Content-Type": "application/json", // Use application/json since we are sending a JSON object
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            // toast?.success("2nd Proof submitted!")
            CustomToast.show('success', 'Success!', '2nd Proof submitted!')
            await fetchDisputeChat();
            setMessage('');
            setFile(null);
            setLoader(false);
        } catch (error) {
            // Log detailed error response if available
            if (error.response) {
                console.error(
                    "API Error:",
                    error.response.data.message || error.response.data
                );
                setLoader(false);
                // toast.error(
                //     `Error submitting task: ${error.response.data.message || "Unknown error"
                //     }`
                // );
                CustomToast.show('error', 'Error!', `Error submitting task: ${error.response.data.message || "Unknown error"
                    }`)
            } else {
                console.error("Error submitting the task:", error);
                setLoader(false);
                // toast.error("Failed to submit the task. Please try again.");
                CustomToast.show('error', 'Error!', 'Failed to submit the task. Please try again.')
            }
        }
    };


    const limit = 10;  // You can change this as needed
    const offset = 1;  // Update for pagination if required
    const id = taskData?.id;  // Extract id from taskData

    const fetchDisputeChat = async () => {
        setLoader(true);
        setError(null);

        const accessToken = localStorage.getItem('accessToken');
        if (!accessToken) {
            setError("Unauthorized: No token found");
            setLoader(false);
            return;
        }

        try {
            const response = await fetch(`${API_URL}disputes-chat/${id}?limit=${limit}&offset=${offset}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${accessToken}`,
                    'Content-Type': 'application/json'
                }
            });

            if (!response.ok) {
                throw new Error(`Error: ${response.statusText}`);
            }

            const data = await response.json();
            console.log(data, "res in disputes chat");

            setMessages(data);
            setDisputeChats(data?.data?.[0]);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoader(false);
        }
    };

    function checkAtLeastTwoCreatorsPresent(chat) {
        console.log("as a creator");

        let count = 0;

        for (let item of chat) {
            if (item.creator) {
                count++;
            }

            if (count >= 2) {
                return false;
            }
        }

        return true;
    }

    function checkAtLeastTwoWinnersPresent(chat, taskData) {
        console.log("as a winner", chat, "sadfsdadisputeChatsdisputeChatsdisputeChats", disputeChats);

        let count = 0;

        for (let item of chat) {
            if (item?.winner == true || taskData?.user?.winner == true) {
                count++;
            }
            if (count > 2) {
                return false;
            }
        }

        return true;
    }

    function checkAtLeastTwoUsersPresent(chat) {
        console.log("as a user", "sadfsdadisputeChatsdisputeChatsdisputeChats", disputeChats);

        let count = 0;

        for (let item of chat) {
            if (item.user) {
                count++;
            }

            if (count >= 2) {
                return false;
            }
        }

        return true;
    }


    useEffect(() => {
        if (disputeChats) {
            const chats = disputeChats?.disputeChats;

            if (taskData?.hasCreator) {
                const result = checkAtLeastTwoCreatorsPresent(chats, taskData);
                setChatEnabled(result);
            }
            else if (disputeChats?.user?.winner) {
                const result = checkAtLeastTwoWinnersPresent(chats, disputeChats);
                console.log(result, "as a winnerr results");

                setChatEnabled(result);
            }
            else if (taskData?.hasCreator === false && !disputeChats?.user?.winner) {
                const result = checkAtLeastTwoUsersPresent(chats, taskData);
                setChatEnabled(result);
            }
        }
    }, [disputeChats]);




    console.log(disputeChats, "disputeChatsdisputeChatsdisputeChats", disputeChats?.user?.winner === true, disputeChats?.user?.winner);


    useEffect(() => {
        if (!id) return;  // Don't fetch if id is missin
        fetchDisputeChat();
    }, [id]);  // Runs when `id` changes


    useEffect(() => {
        if (socket) {
            // Handle the 'NOTIFICATION_ALERT' event here
            socket.on('DISPUTE_MESSAGE_ALERT', (event) => {
                fetchDisputeChat()
            });
        }

    }, [socket]);

    // ================================================================== Uploading profs to IPFS ================================================================== //

    const { submitProofAgainHook } = SubmitProofAgain();
    const { account } = useWeb3React();
    const { taskDisputedDetailsHook } = TaskDisputedDetails();
    const { fetchDisputeTimerHook } = FetchDisputeTimer();
    const [disputeTimer, setDisputeTimer] = useState(null);
    const [epochTime, setEpochTime] = useState(0);
    const [disputeContractRes, setDisputeContractRes] = useState(null);
    console.log(disputeContractRes, "disputeContractResdisputeContractRes");
    console.log(Number(disputeTimer) <= epochTime, Number(disputeTimer), epochTime, "timeeeeeezzzz");

    const taskDisputedDetailsHandle = async () => {
        try {
            const resInDisputeContract = await taskDisputedDetailsHook(taskData?.contractTaskId);
            console.log(resInDisputeContract, "disputeContractRes...");

            setDisputeContractRes(resInDisputeContract);
            return resInDisputeContract;
        } catch (error) {
            CustomToast.show('error', 'Error!', error);
        }
    }

    const getTaskDisputeTimerHandle = async () => {
        try {
            console.log(taskData, 'taskDatataskData')

            let dollorValue = await getDollarValueOfToken(taskData)
            console.log("dollorValue", dollorValue);
            
            const res = await fetchDisputeTimerHook(disputeContractRes?.disputeContract, dollorValue);
            console.log("⏱️ Dispute Timer Response:", res);

            if (!res?.startTime) {
                CustomToast.show('error', 'Error!', 'Invalid dispute timer response');
                setLoader(false);
                return;
            }

            setDisputeTimer(res.startTime);
        } catch (error) {
            console.log(error, "error in fetchDisputeTimerHook disputeContractRes?.disputeContract");

            CustomToast.show('error', 'Error!', error);
        }
    }
//function by Awais
    // const getProofFromIpfs = async (newHash) => {
    //     try {
    //         const oldIpfsUrl = taskData?.participation?.proofIpfsHash?.replace(/^ipfs:\/\//, '').replace(/\/$/, '');
    //         const newIpfsUrl = newHash?.replace(/^ipfs:\/\//, '').replace(/\/$/, '');

    //         if (!oldIpfsUrl || !newIpfsUrl) {
    //             CustomToast.show('error', 'Error!', 'Missing old or new IPFS hash');
    //             return [];
    //         }
    //         const headers = {
    //             'Authorization': `Bearer Rqx69a33k2n255WDx9OlMcxr5f8O4oVMl9J041zFsQd5lCVgCutpKwYxc3Z9QKhU`, // Or your specific API key header
    //             // e.g., 'X-API-KEY': Environment?.IPFS_API_KEY
    //         };

    //         const [oldDataRes, newDataRes] = await Promise.allSettled([
    //             axios.get(`${Environment?.IPFS_URI}${oldIpfsUrl}`, { headers }),
    //             axios.get(`${Environment?.IPFS_URI}${newIpfsUrl}`, { headers })
    //         ]);
    //         // const [oldDataRes, newDataRes] = await Promise.allSettled([
    //         //     axios.get(`${Environment?.IPFS_URI}${oldIpfsUrl}`),
    //         //     axios.get(`${Environment?.IPFS_URI}${newIpfsUrl}`)
    //         // ]);

    //         let oldData = [];
    //         let newData = [];

    //         if (oldDataRes.status === 'fulfilled') {
    //             const d = oldDataRes.value.data;
    //             oldData = Array.isArray(d) ? d : [d];
    //         } else {
    //             console.warn('⚠️ Failed to fetch old IPFS data:', oldDataRes.reason);
    //         }

    //         if (newDataRes.status === 'fulfilled') {
    //             const d = newDataRes.value.data;
    //             newData = Array.isArray(d) ? d : [d];
    //         } else {
    //             console.warn('⚠️ Failed to fetch new IPFS data:', newDataRes.reason);
    //         }

    //         const mergedData = [...oldData, ...newData];

    //         // Final guard: if merged data is empty
    //         if (mergedData.length === 0) {
    //             CustomToast.show('error', 'Error!', 'Failed to retrieve any proof data from IPFS (check your network or hash values)');
    //         }

    //         return mergedData;

    //     } catch (error) {
    //         console.error("❌ Error in getProofFromIpfs:", error);
    //         CustomToast.show('error', 'Error!', 'Unexpected error while retrieving proof data');
    //         return [];
    //     }
    // };
    const getProofFromIpfs = async (newHash) => {
        try {
            const oldIpfsUrl = taskData?.participation?.proofIpfsHash?.replace(/^ipfs:\/\//, '').replace(/\/$/, '');
            const newIpfsUrl = newHash?.replace(/^ipfs:\/\//, '').replace(/\/$/, '');
            console.log(oldIpfsUrl, newIpfsUrl,  'same ipfs url' );

            if (!oldIpfsUrl || !newIpfsUrl) {
                CustomToast.show('error', 'Error!', 'Missing old or new IPFS hash');
                return [];
            }

            // Check if old and new IPFS URLs are the same
            if (oldIpfsUrl === newIpfsUrl) {
                CustomToast.show('error', 'Error!', 'Please upload different proof from the previously submitted one.');
                return [];
            }
            // const ipfsGateways = [
            //     'https://ipfs.io/ipfs/',
            //     'https://gateway.pinata.cloud/ipfs/',
            //     'https://cloudflare-ipfs.com/ipfs/',
            //     'https://dweb.link/ipfs/',
            //     'https://ipfs.infura.io/ipfs/',
            //     'https://gateway.ipfs.io/ipfs/',
            //     'https://ipfs.fleek.co/ipfs/',
            //     'https://hardbin.com/ipfs/',
            //     'https://ipfs.eth.aragon.network/ipfs/',
            //     'https://ipfs.best-practice.se/ipfs/'
            // ];
            const ipfsGateways = [
                "https://gateway.pinata.cloud/ipfs/",
                "https://cf-ipfs.com/ipfs/",
                "https://ipfs.io/ipfs/",
                "https://dweb.link/ipfs/",
                "https://4everland.io/ipfs/",
                "https://w3s.link/ipfs/",
                "https://nftstorage.link/ipfs/",
                "https://storry.tv/ipfs/",
                "https://cloudflare-ipfs.com/ipfs/",
                "https://gateway.originprotocol.com/ipfs/",
                "https://gateway.temporal.cloud/ipfs/",
                "https://gateway.ipfs.io/ipfs/",
                "https://ipfs.eternum.io/ipfs/",
                "https://gateway.serph.network/ipfs/",
                "https://hardbin.com/ipfs/",
                "https://ipfs.jes.xxx/ipfs/",
                "https://gateway.blocksec.com/ipfs/",
                "https://ipfs.mrh.io/ipfs/",
                "https://gateway.fleek.co/ipfs/",
            ];


            // Function to fetch data racing all gateways
            const fetchFromIpfsRace = async (hash) => {
                const promises = ipfsGateways.map(gateway =>
                    axios.get(`${gateway}${hash}`, {
                        timeout: 8000,
                        headers: { 'Accept': 'application/json' }
                    }).then(response => ({ gateway, data: response.data }))
                        .catch(error => ({ gateway, error }))
                );

                // Wait for first successful response
                return new Promise((resolve, reject) => {
                    let completedCount = 0;
                    let errors = [];

                    promises.forEach(promise => {
                        promise.then(result => {
                            completedCount++;

                            if (result.data) {
                                console.log(`✅ First successful gateway: ${result.gateway}`);
                                resolve(result.data);
                            } else {
                                errors.push(result.error);

                                if (completedCount === promises.length) {
                                    reject(new Error(`All gateways failed: ${errors.map(e => e?.message).join(', ')}`));
                                }
                            }
                        });
                    });
                });
            };

            // Fetch data from both hashes
            const [oldDataRes, newDataRes] = await Promise.allSettled([
                fetchFromIpfsRace(oldIpfsUrl),
                fetchFromIpfsRace(newIpfsUrl)
            ]);

            let oldData = [];
            let newData = [];

            if (oldDataRes.status === 'fulfilled') {
                const d = oldDataRes.value;
                oldData = Array.isArray(d) ? d : [d];
            } else {
                console.warn('⚠️ Failed to fetch old IPFS data:', oldDataRes.reason.message);
            }

            if (newDataRes.status === 'fulfilled') {
                const d = newDataRes.value;
                newData = Array.isArray(d) ? d : [d];
            } else {
                console.warn('⚠️ Failed to fetch new IPFS data:', newDataRes.reason.message);
            }

            const mergedData = [...oldData, ...newData];

            if (mergedData.length === 0) {
                CustomToast.show('error', 'Error!', 'Failed to retrieve any proof data from IPFS. All gateways failed or returned empty data.');
            }

            return mergedData;

        } catch (error) {
            console.error("❌ Error in getProofFromIpfs:", error);
            CustomToast.show('error', 'Error!', 'Unexpected error while retrieving proof data');
            return [];
        }
    };
    console.log(account, taskData, message, file, 'account, taskData, message, file');
    
    const secondProofCall = async () => {
        setLoader(true);

        if (!disputeContractRes?.disputeContract) {
            CustomToast.show('error', 'Error!', 'Dispute contract not available');
            setLoader(false);
            return;
        }

        console.log("📄 Dispute Contract:", disputeContractRes?.disputeContract);

        let res;
        try {
            // res = await fetchDisputeTimerHook(disputeContractRes?.disputeContract);
            // console.log("⏱️ Dispute Timer Response:", res);

            // if (!res?.startTime) {
            //     CustomToast.show('error', 'Error!', 'Invalid dispute timer response');
            //     setLoader(false);
            //     return;
            // }

            // setDisputeTimer(res.startTime);

            if (disputeTimer <= epochTime) {
                CustomToast.show('error', 'Error!', 'Dispute time is over');
                setLoader(false);
                return;
            }
        } catch (timerError) {
            console.error("❌ Error fetching dispute timer:", timerError);
            CustomToast.show('error', 'Error!', 'Failed to fetch dispute timer');
            setLoader(false);
            return;
        }

        // Input Validations
        if (!message) {
            CustomToast.show('error', 'Error!', 'Proof message is missing');
            setLoader(false);
            return;
        }

        if (!file) {
            CustomToast.show('error', 'Error!', 'Please select a proof file');
            setLoader(false);
            return;
        }


        try {
            // Upload initial proof
            const ipfsRes = await uploadProofOnIPFS(account, taskData, message, file);
            console.log("📦 IPFS Upload Response:", ipfsRes);

            if (!Array.isArray(ipfsRes) || !ipfsRes[0]) {
                setLoader(false);
                throw new Error("Failed to upload proof to IPFS.");
            }

            let mergedProofArrayHash = null;

            // If no creator, fetch and upload merged proof
            if (!taskData?.hasCreator) {
                try {
                    const mergedProofArray = await getProofFromIpfs(ipfsRes[0]);
                    console.log("📦 Merged Data from IPFS:", mergedProofArray);
                    if (mergedProofArray?.length === 0) {
                        setLoader(false);
                        return;
                    }

                    mergedProofArrayHash = await uploadProofOnIPFS(account, taskData, message, file, mergedProofArray);
                    console.log("✅ Merged Proof IPFS Hash:", mergedProofArrayHash?.[0]);

                    if (!Array.isArray(mergedProofArrayHash) || !mergedProofArrayHash[0]) {
                        setLoader(false);
                        throw new Error("Failed to upload merged proof to IPFS.");
                    }
                } catch (mergeError) {
                    console.error("❌ Merging IPFS proof failed:", mergeError);
                    setLoader(false);
                    CustomToast.show('error', 'Error!', 'Failed to merge and upload proof');
                    return;
                }
            }

            const hashToSubmit = taskData?.hasCreator ? ipfsRes[0] : mergedProofArrayHash?.[0];

            if (!hashToSubmit) {
                CustomToast.show('error', 'Error!', 'No valid IPFS hash to submit');
                setLoader(false);
                return;
            }

            let txResult;
            try {
                txResult = await submitProofAgainHook(taskData?.contractTaskId, hashToSubmit);
                console.log("🎯 Contract Submission Result:", txResult);
            } catch (contractError) {
                console.error("❌ Contract transaction reverted:", contractError);

                if (contractError?.reason) {
                    setLoader(false);
                    CustomToast.show('error', 'Smart Contract Error', contractError.reason);
                } else {
                    setLoader(false);
                    CustomToast.show('error', 'Smart Contract Error', 'Transaction reverted by EVM. Possible reasons: already submitted, not authorized, or invalid hash.');
                }

                return;
            }

            // Final handling
            if (txResult) {
                try {
                    const finalResult = await handleSubmit(txResult, taskData?.hasCreator ? ipfsRes : mergedProofArrayHash);
                    console.log("✅ Final Submit Result:", finalResult);
                    setLoader(false);
                    CustomToast.show('success', 'Success!', 'Proof submitted successfully');
                } catch (submitFinalError) {
                    setLoader(false);
                    console.error("❌ Final Submission Failed:", submitFinalError);
                    CustomToast.show('error', 'Error!', 'Final proof submission failed');
                }
            } else {
                setLoader(false);
                CustomToast.show('error', 'Error!', 'No response from contract submission');
            }

        } catch (error) {
            setLoader(false);
            console.error("❌ Unhandled Error in Proof Flow:", error);
            CustomToast.show('error', 'Error!', error?.message || 'Unexpected error during proof upload');
        } finally {
            setLoader(false);
        }
    };


    // ================================================================== Uploading profs to IPFS ================================================================== //


    useEffect(() => {
        if (!account) return;
        const contractAddress = disputeContractRes?.disputeContract;
        console.log(contractAddress, "disputeContractRes?.disputeContract");
        if (
            contractAddress &&
            contractAddress !== '0x0000000000000000000000000000000000000000'
        ) {
            getTaskDisputeTimerHandle();
        } else {
            taskDisputedDetailsHandle();
        }
    }, [account, disputeContractRes]);


    useEffect(() => {
        const timeInSeconds = Math.floor(Date.now() / 1000);
        setEpochTime(timeInSeconds);
    }, []);

    return (
        <>
            {loading && <Loader />}
            <section className="disputedetail-section">
                <img src="\assets\createtask\backkgroundimg.png" alt="img" className='img-fluid backkgroundimg' />
                <div className="custom-container">
                    <div className="upper-heading">
                        <p>Dispute details</p>
                        <h4>{taskData?.title ? taskData?.title : ""}</h4>
                    </div>
                    <div className="bottom-content">
                        <div className="parent">
                            {
                                taskData?.hasCreator &&
                                <div className="chat-left-box">
                                    <div className="main-head">
                                        {
                                            window.innerWidth <= 600 && selectedItem ?
                                                <span className='disparastyle' onClick={() => setSelectedItem(!selectedItem)}>
                                                    <img src='/assets/back-arrow.svg' alt='back-arrow' /> Dispute Details
                                                </span>
                                                :
                                                <h6 className='disputeformarginonly'>Disputes ({messages?.data?.length})</h6>
                                        }
                                    </div>
                                    <div className={`bottom-users ${window.innerWidth <= 600 && taskData?.hasCreator && selectedItem ? "d-none" : ""}`}>
                                        {messages?.data?.map((item) => {
                                            let user = item?.user
                                            return (
                                                <div
                                                    // onClick={()=>setDisputeChats(item)} 
                                                    // className="single-user active" 
                                                    onClick={() => {
                                                        setDisputeChats(item); // Keep this functionality
                                                        setSelectedItem(item); // Add active class functionality
                                                        setMessage("");
                                                        setFile(null);
                                                    }}
                                                    // className={`single-user ${selectedItem?.id === item?.id ? "active" : ""}`}
                                                    className={`single-user ${selectedItem?.id === item?.id ? "active" : ""}`}
                                                    key={item.id}
                                                >
                                                    <p>{user?.winner ? 'Winner' : 'PARTY'}
                                                        {
                                                            user?.winner ?
                                                                <span>
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                                                        <path d="M11.2383 4.25674C11.2383 4.26189 11.2383 4.26658 11.235 4.27174L10.1719 9.14065C10.1392 9.31209 10.0477 9.46676 9.91317 9.57799C9.77866 9.68923 9.60957 9.75006 9.43503 9.75002H2.56456C2.39009 9.74995 2.22111 9.68907 2.0867 9.57784C1.95229 9.46662 1.86086 9.31201 1.82815 9.14065L0.765026 4.27174C0.765026 4.26658 0.762682 4.26189 0.761744 4.25674C0.732648 4.09554 0.757128 3.92924 0.831444 3.78326C0.90576 3.63728 1.02582 3.51964 1.17329 3.44833C1.32076 3.37701 1.48752 3.35594 1.6481 3.38832C1.80867 3.42071 1.95423 3.50477 2.06253 3.62768L3.64081 5.32877L5.31893 1.56517C5.31901 1.56361 5.31901 1.56205 5.31893 1.56049C5.37894 1.43034 5.47498 1.32011 5.59569 1.24284C5.71639 1.16557 5.85671 1.12451 6.00003 1.12451C6.14334 1.12451 6.28366 1.16557 6.40437 1.24284C6.52507 1.32011 6.62111 1.43034 6.68112 1.56049C6.68104 1.56205 6.68104 1.56361 6.68112 1.56517L8.35924 5.32877L9.93753 3.62768C10.046 3.50569 10.1914 3.42244 10.3515 3.39059C10.5117 3.35873 10.6778 3.38 10.8248 3.45117C10.9717 3.52233 11.0914 3.63951 11.1657 3.7849C11.24 3.93029 11.2649 4.09596 11.2364 4.25674H11.2383Z" fill="#FF9500" />
                                                                    </svg>
                                                                    Winner
                                                                </span>
                                                                : null
                                                        }
                                                    </p>
                                                    <div className="profile-detail">
                                                        <div className="main-img">
                                                            <img src={user?.imageUrl ? user?.imageUrl : "/assets/dummy/profile.png"} alt="img" className='img-fluid' />
                                                        </div>
                                                        <h5>{user?.name ? user.name : user.walletAddress?.slice(0, 10)}</h5>
                                                    </div>
                                                    <a className='next-arrow-on-mobile d-none'>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                                                            <path d="M7.5 6L10.5 9L7.5 12" stroke="#013159" stroke-width="1.5" stroke-linecap="square" />
                                                        </svg>
                                                    </a>
                                                </div>
                                            )
                                        })}

                                    </div>
                                </div>
                            }
                            <div className={`chat-right-box ${window.innerWidth <= 600 && taskData?.hasCreator && !selectedItem ? "d-none" : ""}`}>
                                {/* <div className="d-none upper-headingmobilechat">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
  <path d="M14 16.5L10 12.5L14 8.5" stroke="#013159" stroke-width="1.5" stroke-linecap="square"/>
</svg>
                                    <h6>Dispute Details</h6>
                                </div> */}
                                <div className='forpaddingcardss'>
                                    <div className="upper-detail">
                                        <div className="single-item">
                                            <p>Reward</p>
                                            <h6><img src={
                                                tokenImages[taskData?.currencySymbol] ||
                                                "/assets/edituploadimg.png"
                                            } alt="img" className='img-fluid party' />{
                                                    parseFloat(taskData?.reward) > 1000
                                                        ? parseFloat(taskData?.reward).toLocaleString() // Format with commas if > 1000
                                                        : Number(taskData?.reward) % 1 === 0
                                                            ? parseFloat(taskData?.reward).toFixed(0) // No decimal places if it's an integer
                                                            : parseFloat(taskData?.reward).toFixed(4) // Show 4 decimal places if it's a decimal
                                                }{" "}
                                                {taskData?.currencySymbol}</h6>
                                        </div>
                                        <div className="single-item">
                                            <p>Dispute created</p>
                                            {/* <h6>{new Date(disputeChats?.createdAt)?.toLocaleString()}</h6> */}
                                            <h6 className='text-uppercase'>
                                                {new Date(disputeChats?.createdAt)?.toLocaleString("en-GB", {
                                                    day: "2-digit",
                                                    month: "2-digit",
                                                    year: "numeric",
                                                    hour: "2-digit",
                                                    minute: "2-digit",
                                                    hour12: true,
                                                }).replace(",", "")}
                                            </h6>

                                        </div>
                                        <div className="single-item">
                                            <p>Category</p>
                                            <h6>  {taskData?.tasksCategory?.categoryName}</h6>
                                        </div>
                                        <div className="single-item">
                                            <p>PARTY</p>
                                            <h6>
                                                {disputeChats?.user?.imageUrl ? (
                                                    <img
                                                        src={
                                                            disputeChats?.user?.imageUrl.startsWith("http")
                                                                ? disputeChats.user.imageUrl
                                                                : `https://${disputeChats.user.imageUrl}`
                                                        }
                                                        alt="img" className='img-fluid party'
                                                    />
                                                ) : null}
                                                {disputeChats?.user?.name ||
                                                    disputeChats?.user?.walletAddress?.slice(0, 5) +
                                                    "..." +
                                                    disputeChats?.user?.walletAddress?.slice(-5)}

                                            </h6>
                                        </div>
                                        <div className="single-item">
                                            <p>TX HASH</p>
                                            <a target="_blank"
                                                href={`${taskData?.id > intitial_production_eth_id ? Environment?.trxHashUrl_Arb : Environment?.trxHashUrl}/tx/${taskData?.taskTransactionHash}`}>  {taskData?.taskTransactionHash?.slice(0, 8)}...{" "} <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                                    <path d="M9.5498 2.375H13.9248V6.75M13.9248 9.71063V12.6875C13.9248 12.9361 13.826 13.1746 13.6502 13.3504C13.4744 13.5262 13.2359 13.625 12.9873 13.625H3.6123C3.36366 13.625 3.12521 13.5262 2.94939 13.3504C2.77358 13.1746 2.6748 12.9361 2.6748 12.6875V3.3125C2.6748 3.06386 2.77358 2.8254 2.94939 2.64959C3.12521 2.47377 3.36366 2.375 3.6123 2.375H6.4248M8.8623 7.4375L13.6436 2.65625" stroke="#627F97" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                                                </svg></a>
                                        </div>
                                    </div>
                                </div>
                                <div className='brdr d-none'></div>
                                <div className="bottom-chat">
                                    <div className="chat-parent">
                                        {disputeChats?.disputeChats?.map((msg) => {
                                            const isCreator = msg.creator !== null;
                                            const sender = isCreator ? msg.creator : msg.user;
                                            const profileImg = sender?.imageUrl || msg?.winner?.imageUrl || "/assets/dummy/profile.png";
                                            const formattedDate = new Date(msg?.createdAt)?.toLocaleString("en-GB", {
                                                day: "2-digit",
                                                month: "2-digit",
                                                year: "numeric",
                                                hour: "2-digit",
                                                minute: "2-digit",
                                                hour12: true,
                                            }).replace(",", "")


                                            return (
                                                <div key={msg.id} className={isCreator ? "user-side" : "my-side"}>
                                                    <div className="twice-content">
                                                        <div className="user-profile">
                                                            <img src={profileImg} alt="Profile" className="img-fluid" />
                                                        </div>
                                                        <div className="right-detail">
                                                            <h6 className="main-text"> {isCreator ? `${sender?.name} have submitted a response to your dispute claim.` : 'Your dispute claim is submitted'}.</h6>
                                                            <p className="main-para">{msg.message}</p>

                                                            {msg.proofOfWork && msg.proofOfWork.length > 0 && (
                                                                <div className="document-detail">
                                                                    <h5>{msg?.proofOfWork?.[0]?.split("-").pop()}</h5>
                                                                    <div className="twice-btns">
                                                                        <a href={msg?.proofOfWork?.[0]} target='_blank'>
                                                                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                                                <path d="M1.7181 10.2901C1.64865 10.103 1.64865 9.89715 1.7181 9.71006C2.39452 8.06993 3.5427 6.66759 5.01708 5.6808C6.49146 4.69402 8.22564 4.16724 9.99977 4.16724C11.7739 4.16724 13.5081 4.69402 14.9825 5.6808C16.4568 6.66759 17.605 8.06993 18.2814 9.71006C18.3509 9.89715 18.3509 10.103 18.2814 10.2901C17.605 11.9302 16.4568 13.3325 14.9825 14.3193C13.5081 15.3061 11.7739 15.8329 9.99977 15.8329C8.22564 15.8329 6.49146 15.3061 5.01708 14.3193C3.5427 13.3325 2.39452 11.9302 1.7181 10.2901Z" stroke="#013159" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                                                <path d="M10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5Z" stroke="#013159" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                                                            </svg>
                                                                        </a>
                                                                        <a href={msg?.proofOfWork?.[0]} target='_blank' className='btn-view'>View</a>
                                                                    </div>
                                                                </div>
                                                            )}

                                                            {isCreator && (
                                                                (msg.proofOfWork && msg.proofOfWork.length > 0) ? null : <div className={"document-detail myside-document"}>
                                                                    <div className="twice-btns">
                                                                        <a onClick={() => navigate(-1)} className="btn-view">View Task Details</a>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <p className="timer-text text-uppercase">{formattedDate}</p>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            </div>
                        </div>




                        {console.log('Winner value type:', typeof disputeChats?.user?.winner, disputeChats?.user?.winner, disputeChats?.user?.winner == true ? "sadfsda" : null)}

                    </div>
                    {
                        Number(disputeTimer) >= epochTime ?
                            (
                                status === 'inDisputePeriod' &&
                                taskData.disputeType === "regular"
                                &&
                                chatEnabled
                            ) && (
                                disputeChats?.user?.winner === true && taskData?.winnerId == taskData?.user?.id ?
                                    <div className='asdfadsfdsf'>
                                        <div className='mmmmmm'>
                                            <div className='submitcardbottommain p-0 border-0'>
                                                {/* <div className='uppertextmainnnn'>
                                                <h3 className='mainhead'>Submit your final statement</h3>
                                                <p className='mainpara'>This response will be visible to all parties involved in the dispute.</p>
                                            </div> */}

                                                <div className='innersubmitmaincard'>
                                                    <div className='parentsubmitinner'>
                                                        <div className='left w-75'>
                                                            <textarea type="text" value={message} onChange={(e) => setMessage(e.target.value)} placeholder='Type your proof messege 2' className='w-100' />
                                                        </div>
                                                        <div className='right'>
                                                            <div className='twicepicture'>
                                                                <div className='uploadcardmainddddddd'>
                                                                    <div className='upoadleft'>
                                                                        <div className='maininput'>
                                                                            <div className='wrapper'>
                                                                                <label htmlFor='upload'>
                                                                                    {/* SVG Icon */}
                                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                                                        <path d="M16.3794 9.55805C16.4375 9.6161 16.4836 9.68503 16.5151 9.7609C16.5465 9.83678 16.5627 9.91811 16.5627 10.0002C16.5627 10.0824 16.5465 10.1637 16.5151 10.2396C16.4836 10.3155 16.4375 10.3844 16.3794 10.4424L9.96925 16.8487C9.14863 17.6692 8.03568 18.1301 6.87522 18.13C5.71477 18.13 4.60187 17.6689 3.78136 16.8483C2.96085 16.0277 2.49993 14.9147 2.5 13.7543C2.50007 12.5938 2.96113 11.4809 3.78175 10.6604L11.5364 2.79165C12.1223 2.20517 12.9171 1.87544 13.7461 1.875C14.5751 1.87456 15.3703 2.20345 15.9568 2.78931C16.5432 3.37516 16.873 4.17001 16.8734 4.99898C16.8738 5.82795 16.545 6.62314 15.9591 7.20962L8.20284 15.0784C7.8506 15.4306 7.37286 15.6285 6.87472 15.6285C6.37657 15.6285 5.89883 15.4306 5.54659 15.0784C5.19435 14.7261 4.99647 14.2484 4.99647 13.7502C4.99647 13.2521 5.19435 12.7744 5.54659 12.4221L12.0544 5.81118C12.1114 5.75037 12.18 5.70157 12.2562 5.66766C12.3323 5.63376 12.4145 5.61543 12.4978 5.61375C12.5811 5.61207 12.664 5.62708 12.7414 5.6579C12.8189 5.68871 12.8894 5.73471 12.9488 5.79318C13.0082 5.85165 13.0553 5.92141 13.0874 5.99836C13.1194 6.07531 13.1357 6.1579 13.1354 6.24125C13.135 6.32461 13.118 6.40705 13.0853 6.48373C13.0526 6.56041 13.0049 6.62977 12.945 6.68774L6.43644 13.3057C6.37816 13.3635 6.33185 13.4322 6.30013 13.508C6.26842 13.5837 6.25193 13.6649 6.2516 13.747C6.25127 13.8291 6.26712 13.9104 6.29823 13.9864C6.32934 14.0623 6.37511 14.1314 6.43292 14.1897C6.49073 14.248 6.55946 14.2943 6.63517 14.326C6.71088 14.3577 6.7921 14.3742 6.87419 14.3745C6.95627 14.3749 7.03762 14.359 7.11358 14.3279C7.18954 14.2968 7.25863 14.251 7.31691 14.1932L15.0724 6.32837C15.4246 5.97685 15.6228 5.49981 15.6233 5.00218C15.6238 4.50455 15.4266 4.02709 15.0751 3.67485C14.7236 3.32261 14.2465 3.12444 13.7489 3.12392C13.2513 3.12341 12.7738 3.3206 12.4216 3.67212L4.66847 11.5377C4.37802 11.8277 4.14754 12.1721 3.99017 12.5511C3.8328 12.9302 3.75164 13.3365 3.75131 13.747C3.75099 14.1574 3.8315 14.5639 3.98827 14.9432C4.14503 15.3225 4.37497 15.6672 4.66495 15.9577C4.95494 16.2481 5.29929 16.4786 5.67835 16.636C6.05741 16.7933 6.46376 16.8745 6.87419 16.8748C7.28461 16.8751 7.69109 16.7946 8.0704 16.6379C8.44971 16.4811 8.79443 16.2512 9.08488 15.9612L15.4958 9.55493C15.6134 9.43822 15.7726 9.37299 15.9383 9.37358C16.1039 9.37416 16.2626 9.44052 16.3794 9.55805Z" fill="#013159" />
                                                                                    </svg>
                                                                                </label>
                                                                                <input id="upload" type="file" accept=".pdf,.jpg,.png" onChange={handleFileUpload} hidden />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className='secondimg' onClick={() => secondProofCall()}>
                                                                    <img src='\IconSet.svg' alt='img' className='img-fluid forwidth' />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {file && (
                                                        <div className='uploadcardmain'>
                                                            <div className='upoadleft'>
                                                                <img src='\Frame22222.png' alt='img' className='img-fluid' />
                                                            </div>
                                                            <div className='upoadright'>
                                                                <h6>{file?.name?.slice(0, 20)}</h6>
                                                                <p>{(file.size / 1024 / 1024).toFixed(2)} MB</p>
                                                            </div>
                                                            {
                                                                file ?
                                                                    <img src='/cross_Icon.svg' className='img-fluid loader' onClick={() => handleRemoveFile()} />
                                                                    :
                                                                    <img src='\uploadmain.svg' alt='img' className='img-fluid loader' />
                                                            }
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    :
                                    taskData?.hasCreator && taskData?.hasCreatorSubmit2ndProof == false ? (
                                        (
                                            disputeContractRes?.winnerAddress == null ||
                                            disputeContractRes?.winnerAddress == '' ||
                                            disputeContractRes?.winnerAddress == '0x0000000000000000000000000000000000000000' ||
                                            disputeContractRes?.winnerAddress == account
                                        ) ?
                                            <div className='mmmmmm'>
                                                <div className='submitcardbottommain'>
                                                    <div className='uppertextmainnnn'>
                                                        <h3 className='mainhead'>Submit your final statement</h3>
                                                        <p className='mainpara'>This response will be visible to all parties involved in the dispute.</p>
                                                    </div>

                                                    <div className='innersubmitmaincard'>
                                                        <div className='parentsubmitinner'>
                                                            <div className='left w-75'>
                                                                <textarea type="text" value={message} onChange={(e) => setMessage(e.target.value)} placeholder='Type your proof messege 1' className='w-100' />
                                                            </div>
                                                            <div className='right'>
                                                                <div className='twicepicture'>
                                                                    <div className='uploadcardmainddddddd'>
                                                                        <div className='upoadleft'>
                                                                            <div className='maininput'>
                                                                                <div className='wrapper'>
                                                                                    <label htmlFor='upload'>
                                                                                        {/* SVG Icon */}
                                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                                                            <path d="M16.3794 9.55805C16.4375 9.6161 16.4836 9.68503 16.5151 9.7609C16.5465 9.83678 16.5627 9.91811 16.5627 10.0002C16.5627 10.0824 16.5465 10.1637 16.5151 10.2396C16.4836 10.3155 16.4375 10.3844 16.3794 10.4424L9.96925 16.8487C9.14863 17.6692 8.03568 18.1301 6.87522 18.13C5.71477 18.13 4.60187 17.6689 3.78136 16.8483C2.96085 16.0277 2.49993 14.9147 2.5 13.7543C2.50007 12.5938 2.96113 11.4809 3.78175 10.6604L11.5364 2.79165C12.1223 2.20517 12.9171 1.87544 13.7461 1.875C14.5751 1.87456 15.3703 2.20345 15.9568 2.78931C16.5432 3.37516 16.873 4.17001 16.8734 4.99898C16.8738 5.82795 16.545 6.62314 15.9591 7.20962L8.20284 15.0784C7.8506 15.4306 7.37286 15.6285 6.87472 15.6285C6.37657 15.6285 5.89883 15.4306 5.54659 15.0784C5.19435 14.7261 4.99647 14.2484 4.99647 13.7502C4.99647 13.2521 5.19435 12.7744 5.54659 12.4221L12.0544 5.81118C12.1114 5.75037 12.18 5.70157 12.2562 5.66766C12.3323 5.63376 12.4145 5.61543 12.4978 5.61375C12.5811 5.61207 12.664 5.62708 12.7414 5.6579C12.8189 5.68871 12.8894 5.73471 12.9488 5.79318C13.0082 5.85165 13.0553 5.92141 13.0874 5.99836C13.1194 6.07531 13.1357 6.1579 13.1354 6.24125C13.135 6.32461 13.118 6.40705 13.0853 6.48373C13.0526 6.56041 13.0049 6.62977 12.945 6.68774L6.43644 13.3057C6.37816 13.3635 6.33185 13.4322 6.30013 13.508C6.26842 13.5837 6.25193 13.6649 6.2516 13.747C6.25127 13.8291 6.26712 13.9104 6.29823 13.9864C6.32934 14.0623 6.37511 14.1314 6.43292 14.1897C6.49073 14.248 6.55946 14.2943 6.63517 14.326C6.71088 14.3577 6.7921 14.3742 6.87419 14.3745C6.95627 14.3749 7.03762 14.359 7.11358 14.3279C7.18954 14.2968 7.25863 14.251 7.31691 14.1932L15.0724 6.32837C15.4246 5.97685 15.6228 5.49981 15.6233 5.00218C15.6238 4.50455 15.4266 4.02709 15.0751 3.67485C14.7236 3.32261 14.2465 3.12444 13.7489 3.12392C13.2513 3.12341 12.7738 3.3206 12.4216 3.67212L4.66847 11.5377C4.37802 11.8277 4.14754 12.1721 3.99017 12.5511C3.8328 12.9302 3.75164 13.3365 3.75131 13.747C3.75099 14.1574 3.8315 14.5639 3.98827 14.9432C4.14503 15.3225 4.37497 15.6672 4.66495 15.9577C4.95494 16.2481 5.29929 16.4786 5.67835 16.636C6.05741 16.7933 6.46376 16.8745 6.87419 16.8748C7.28461 16.8751 7.69109 16.7946 8.0704 16.6379C8.44971 16.4811 8.79443 16.2512 9.08488 15.9612L15.4958 9.55493C15.6134 9.43822 15.7726 9.37299 15.9383 9.37358C16.1039 9.37416 16.2626 9.44052 16.3794 9.55805Z" fill="#013159" />
                                                                                        </svg>
                                                                                    </label>
                                                                                    <input id="upload" type="file" accept=".pdf,.jpg,.png" onChange={handleFileUpload} hidden />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className='secondimg' onClick={() => secondProofCall()}>
                                                                        <img src='\IconSet.svg' alt='img' className='img-fluid forwidth' />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {file && (
                                                            <div className='uploadcardmain'>
                                                                <div className='upoadleft'>
                                                                    <img src='\Frame22222.png' alt='img' className='img-fluid' />
                                                                </div>
                                                                <div className='upoadright'>
                                                                    <h6>{file?.name?.slice(0, 20)}</h6>
                                                                    <p>{(file.size / 1024 / 1024).toFixed(2)} MB</p>
                                                                </div>
                                                                {
                                                                    file ?
                                                                        <img src='/cross_Icon.svg' className='img-fluid loader' onClick={() => handleRemoveFile()} />
                                                                        :
                                                                        <img src='\uploadmain.svg' alt='img' className='img-fluid loader' />
                                                                }
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                            : null

                                    ) : (
                                        <>
                                            <div className='mmmmmm'>
                                                <div className='submitcardbottommain p-0 border-0'>
                                                    {/* <div className='uppertextmainnnn'>
                                                <h3 className='mainhead'>Submit your final statement</h3>
                                                <p className='mainpara'>This response will be visible to all parties involved in the dispute.</p>
                                            </div> */}

                                                    <div className='innersubmitmaincard'>
                                                        <div className='parentsubmitinner'>
                                                            <div className='left w-75'>
                                                                <textarea type="text" value={message} onChange={(e) => setMessage(e.target.value)} placeholder='Type your proof messege 3' className='w-100' />
                                                            </div>
                                                            <div className='right'>
                                                                <div className='twicepicture'>
                                                                    <div className='uploadcardmainddddddd'>
                                                                        <div className='upoadleft'>
                                                                            <div className='maininput'>
                                                                                <div className='wrapper'>
                                                                                    <label htmlFor='upload'>
                                                                                        {/* SVG Icon */}
                                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                                                            <path d="M16.3794 9.55805C16.4375 9.6161 16.4836 9.68503 16.5151 9.7609C16.5465 9.83678 16.5627 9.91811 16.5627 10.0002C16.5627 10.0824 16.5465 10.1637 16.5151 10.2396C16.4836 10.3155 16.4375 10.3844 16.3794 10.4424L9.96925 16.8487C9.14863 17.6692 8.03568 18.1301 6.87522 18.13C5.71477 18.13 4.60187 17.6689 3.78136 16.8483C2.96085 16.0277 2.49993 14.9147 2.5 13.7543C2.50007 12.5938 2.96113 11.4809 3.78175 10.6604L11.5364 2.79165C12.1223 2.20517 12.9171 1.87544 13.7461 1.875C14.5751 1.87456 15.3703 2.20345 15.9568 2.78931C16.5432 3.37516 16.873 4.17001 16.8734 4.99898C16.8738 5.82795 16.545 6.62314 15.9591 7.20962L8.20284 15.0784C7.8506 15.4306 7.37286 15.6285 6.87472 15.6285C6.37657 15.6285 5.89883 15.4306 5.54659 15.0784C5.19435 14.7261 4.99647 14.2484 4.99647 13.7502C4.99647 13.2521 5.19435 12.7744 5.54659 12.4221L12.0544 5.81118C12.1114 5.75037 12.18 5.70157 12.2562 5.66766C12.3323 5.63376 12.4145 5.61543 12.4978 5.61375C12.5811 5.61207 12.664 5.62708 12.7414 5.6579C12.8189 5.68871 12.8894 5.73471 12.9488 5.79318C13.0082 5.85165 13.0553 5.92141 13.0874 5.99836C13.1194 6.07531 13.1357 6.1579 13.1354 6.24125C13.135 6.32461 13.118 6.40705 13.0853 6.48373C13.0526 6.56041 13.0049 6.62977 12.945 6.68774L6.43644 13.3057C6.37816 13.3635 6.33185 13.4322 6.30013 13.508C6.26842 13.5837 6.25193 13.6649 6.2516 13.747C6.25127 13.8291 6.26712 13.9104 6.29823 13.9864C6.32934 14.0623 6.37511 14.1314 6.43292 14.1897C6.49073 14.248 6.55946 14.2943 6.63517 14.326C6.71088 14.3577 6.7921 14.3742 6.87419 14.3745C6.95627 14.3749 7.03762 14.359 7.11358 14.3279C7.18954 14.2968 7.25863 14.251 7.31691 14.1932L15.0724 6.32837C15.4246 5.97685 15.6228 5.49981 15.6233 5.00218C15.6238 4.50455 15.4266 4.02709 15.0751 3.67485C14.7236 3.32261 14.2465 3.12444 13.7489 3.12392C13.2513 3.12341 12.7738 3.3206 12.4216 3.67212L4.66847 11.5377C4.37802 11.8277 4.14754 12.1721 3.99017 12.5511C3.8328 12.9302 3.75164 13.3365 3.75131 13.747C3.75099 14.1574 3.8315 14.5639 3.98827 14.9432C4.14503 15.3225 4.37497 15.6672 4.66495 15.9577C4.95494 16.2481 5.29929 16.4786 5.67835 16.636C6.05741 16.7933 6.46376 16.8745 6.87419 16.8748C7.28461 16.8751 7.69109 16.7946 8.0704 16.6379C8.44971 16.4811 8.79443 16.2512 9.08488 15.9612L15.4958 9.55493C15.6134 9.43822 15.7726 9.37299 15.9383 9.37358C16.1039 9.37416 16.2626 9.44052 16.3794 9.55805Z" fill="#013159" />
                                                                                        </svg>
                                                                                    </label>
                                                                                    <input id="upload" type="file" accept=".pdf,.jpg,.png" onChange={handleFileUpload} hidden />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className='secondimg' onClick={() => secondProofCall()}>
                                                                        <img src='\IconSet.svg' alt='img' className='img-fluid forwidth' />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {file && (
                                                            <div className='uploadcardmain'>
                                                                <div className='upoadleft'>
                                                                    <img src='\Frame22222.png' alt='img' className='img-fluid' />
                                                                </div>
                                                                <div className='upoadright'>
                                                                    <h6>{file?.name?.slice(0, 20)}</h6>
                                                                    <p>{(file.size / 1024 / 1024).toFixed(2)} MB</p>
                                                                </div>
                                                                {
                                                                    file ?
                                                                        <img src='/cross_Icon.svg' className='img-fluid loader' onClick={() => handleRemoveFile()} />
                                                                        :
                                                                        <img src='\uploadmain.svg' alt='img' className='img-fluid loader' />
                                                                }
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    )
                            )
                            :
                            null
                    }
                    <div className='oracles-box forpaddingcardss'>
                        <p>
                            {
                                taskData?.status === "inDispute" &&
                                "The dispute is currently under review by"
                            }
                            {
                                taskData?.status === "disputeResolved" && taskData?.disputeWinnerId === taskData?.userId &&
                                "voted to refund the creator."
                            }
                            {
                                taskData?.status === "disputeResolved" && taskData?.disputeWinnerId === taskData?.winnerId &&
                                <>
                                    voted to reward the selected winner &nbsp;
                                    <div className='d-flex'>
                                        <p>{disputeChats?.user?.name}</p>
                                        <img src={disputeChats?.user?.imageUrl} />
                                    </div>
                                </>
                            }
                            {
                                taskData?.status === "disputeResolved" && (taskData?.disputeWinnerId !== taskData?.winnerId && taskData?.disputeWinnerId !== taskData?.userId) &&
                                "Oracles selected a new winner."
                            }
                        </p>
                        <img src='/assets/doporacle.svg' alt='' />
                        {/* <p>voted to refund the creator.</p> */}
                    </div>
                </div>
            </section>
        </>
    )
}

export default DisputeDetail;